(() => {
  if (customElements.get('features-swiper')) {
    return;
  }

  class FeaturesSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.options = {
        slidesPerView: 1,
        loop: true,
        watchSlidesProgress: true,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('features-swiper', FeaturesSwiper);
})();